import { gql } from "@apollo/client";

export default gql`
  mutation updateimportedPrivateJobs($data: UpdateImportedPrivateJobInput!) {
    updateimportedPrivateJobs(data: $data)
  }
`;
